import { render, staticRenderFns } from "./video.vue?vue&type=template&id=5aab64c7&scoped=true&lang=pug&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aab64c7",
  null
  
)

export default component.exports